"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9051],{

/***/ 79051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CurrencySearchModal; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/uikit/src/widgets/Modal/styles.tsx
var styles = __webpack_require__(26033);
// EXTERNAL MODULE: ../../packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(62392);
// EXTERNAL MODULE: ../../packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(62208);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(48497);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(48608);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19453);
// EXTERNAL MODULE: ../../packages/hooks/src/index.ts + 10 modules
var src = __webpack_require__(39655);
// EXTERNAL MODULE: ../../packages/localization/src/index.tsx + 6 modules
var localization_src = __webpack_require__(65957);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(13670);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(89495);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(13023);
// EXTERNAL MODULE: ./src/hooks/useNativeCurrency.ts
var useNativeCurrency = __webpack_require__(5369);
// EXTERNAL MODULE: ./src/state/lists/hooks.ts + 3 modules
var hooks = __webpack_require__(7083);
// EXTERNAL MODULE: ../../packages/token-lists/src/index.ts + 4 modules
var token_lists_src = __webpack_require__(72640);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(72135);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(5305);
// EXTERNAL MODULE: ./src/hooks/useActiveChainId.ts
var useActiveChainId = __webpack_require__(76166);
// EXTERNAL MODULE: ./src/hooks/Tokens.ts
var Tokens = __webpack_require__(31196);
// EXTERNAL MODULE: ./src/components/Layout/Column.tsx
var Column = __webpack_require__(77253);
// EXTERNAL MODULE: ./src/components/Layout/Row.tsx
var Layout_Row = __webpack_require__(26830);
// EXTERNAL MODULE: ../../packages/uikit/src/components/QuestionHelper/index.tsx
var QuestionHelper = __webpack_require__(72963);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(92794);
// EXTERNAL MODULE: ./src/components/Logo/index.ts + 2 modules
var Logo = __webpack_require__(47269);
// EXTERNAL MODULE: ./src/components/SearchModal/types.ts
var types = __webpack_require__(34188);
;// CONCATENATED MODULE: ./src/components/SearchModal/CommonBases.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  vertical-align: top;\n  margin-right: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 10px;\n  display: flex;\n  padding: 6px;\n  align-items: center;\n  :hover {\n    cursor: ",
        ";\n    background-color: ",
        ";\n  }\n  background-color: ",
        ";\n  opacity: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  &::-webkit-scrollbar {\n    display: none;\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b751c0b4-0"
})(_templateObject());
var BaseWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b751c0b4-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, disable = param.disable;
    return disable ? "transparent" : theme.colors.dropdown;
}, function(param) {
    var disable = param.disable;
    return !disable && "pointer";
}, function(param) {
    var theme = param.theme, disable = param.disable;
    return !disable && theme.colors.background;
}, function(param) {
    var theme = param.theme, disable = param.disable;
    return disable && theme.colors.dropdown;
}, function(param) {
    var disable = param.disable;
    return disable && "0.4";
});
var RowWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b751c0b4-2"
})(_templateObject2());
function CommonBases(param) {
    var chainId = param.chainId, onSelect = param.onSelect, selectedCurrency = param.selectedCurrency, commonBasesType = param.commonBasesType;
    var native = (0,useNativeCurrency/* default */.Z)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var pinTokenDescText = commonBasesType === types/* CommonBasesType.SWAP_LIMITORDER */.L0.SWAP_LIMITORDER ? t("Common tokens") : t("Common bases");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
        gap: "md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Row/* AutoRow */.BA, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        children: pinTokenDescText
                    }),
                    commonBasesType === types/* CommonBasesType.LIQUIDITY */.L0.LIQUIDITY && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* QuestionHelper */.s, {
                        text: t("These tokens are commonly paired with other tokens."),
                        ml: "4px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseWrapper, {
                            onClick: function() {
                                if (!selectedCurrency || !selectedCurrency.isNative) {
                                    onSelect(native);
                                }
                            },
                            disable: selectedCurrency === null || selectedCurrency === void 0 ? void 0 : selectedCurrency.isNative,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                    currency: native,
                                    style: {
                                        marginRight: 8
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: native === null || native === void 0 ? void 0 : native.symbol
                                })
                            ]
                        })
                    }),
                    (chainId ? exchange/* SUGGESTED_BASES */.kx[chainId] || [] : []).map(function(token) {
                        var selected = selectedCurrency === null || selectedCurrency === void 0 ? void 0 : selectedCurrency.equals(token);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseWrapper, {
                                onClick: function() {
                                    return !selected && onSelect(token);
                                },
                                disable: selected,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                        currency: token,
                                        style: {
                                            marginRight: 8,
                                            borderRadius: "50%"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: token.symbol
                                    })
                                ]
                            })
                        }, "buttonBase#".concat(token.address));
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/react-window/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(36979);
// EXTERNAL MODULE: ./src/utils/wrappedCurrency.ts
var wrappedCurrency = __webpack_require__(94250);
// EXTERNAL MODULE: ./src/components/Card/index.tsx
var Card = __webpack_require__(27156);
// EXTERNAL MODULE: ../../packages/wagmi/dist/index.mjs
var dist = __webpack_require__(9270);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var wallet_hooks = __webpack_require__(33472);
// EXTERNAL MODULE: ./src/components/Loader/CircleLoader.tsx
var CircleLoader = __webpack_require__(88549);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/CheckmarkCircle.tsx
var CheckmarkCircle = __webpack_require__(10396);
// EXTERNAL MODULE: ./src/components/Logo/CurrencyLogo.tsx
var CurrencyLogo = __webpack_require__(39999);
;// CONCATENATED MODULE: ./src/components/SearchModal/ImportRow.tsx

function ImportRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4px 20px;\n  height: 56px;\n  display: grid;\n  grid-template-columns: auto minmax(auto, 1fr) auto;\n  grid-gap: 10px;\n  align-items: center;\n\n  opacity: ",
        ";\n\n  ",
        " {\n    grid-gap: 16px;\n  }\n"
    ]);
    ImportRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ImportRow_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 16px;\n  width: 16px;\n  margin-right: 6px;\n  stroke: ",
        ";\n"
    ]);
    ImportRow_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ImportRow_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 140px;\n  font-size: 12px;\n"
    ]);
    ImportRow_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var TokenSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61f4167b-0"
})(ImportRow_templateObject(), function(param) {
    var dim = param.dim;
    return dim ? "0.4" : "1";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var CheckIcon = (0,styled_components_browser_esm/* default */.ZP)(CheckmarkCircle/* default */.Z).withConfig({
    componentId: "sc-61f4167b-1"
})(ImportRow_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.success;
});
var NameOverflow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61f4167b-2"
})(ImportRow_templateObject2());
function ImportRow(param) {
    var token = param.token, style = param.style, dim = param.dim, showImportView = param.showImportView, setImportToken = param.setImportToken;
    var ref, ref1;
    // globals
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    // check if token comes from list
    var inactiveTokenList = (0,hooks/* useCombinedInactiveList */.qB)();
    var list = (token === null || token === void 0 ? void 0 : token.chainId) && (inactiveTokenList === null || inactiveTokenList === void 0 ? void 0 : (ref = inactiveTokenList[token.chainId]) === null || ref === void 0 ? void 0 : (ref1 = ref[token.address]) === null || ref1 === void 0 ? void 0 : ref1.list);
    // check if already active on list or local storage tokens
    var isAdded = (0,Tokens/* useIsUserAddedToken */.EH)(token);
    var isActive = (0,Tokens/* useIsTokenActive */.ZN)(token);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TokenSection, {
        style: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* default */.Z, {
                currency: token,
                size: isMobile ? "20px" : "24px",
                style: {
                    opacity: dim ? "0.6" : "1"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                gap: "4px",
                style: {
                    opacity: dim ? "0.6" : "1"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Row/* AutoRow */.BA, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mr: "8px",
                                children: token.symbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textDisabled",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NameOverflow, {
                                    title: token.name,
                                    children: token.name
                                })
                            })
                        ]
                    }),
                    list && list.logoURI && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Row/* RowFixed */.DA, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: isMobile ? "10px" : "14px",
                                mr: "4px",
                                color: "textSubtle",
                                children: [
                                    t("via"),
                                    " ",
                                    list.name
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* ListLogo */._r, {
                                logoURI: list.logoURI,
                                size: "12px"
                            })
                        ]
                    })
                ]
            }),
            !isActive && !isAdded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                scale: isMobile ? "sm" : "md",
                width: "fit-content",
                onClick: function() {
                    if (setImportToken) {
                        setImportToken(token);
                    }
                    showImportView();
                },
                children: t("Import")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Row/* RowFixed */.DA, {
                style: {
                    minWidth: "fit-content"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "success",
                        children: "Active"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/SearchModal/CurrencyList.tsx


function CurrencyList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 5rem;\n  text-overflow: ellipsis;\n"
    ]);
    CurrencyList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CurrencyList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4px 20px;\n  height: 56px;\n  display: grid;\n  grid-gap: 16px;\n  align-items: center;\n"
    ]);
    CurrencyList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CurrencyList_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4px 20px;\n  height: 56px;\n  display: grid;\n  grid-template-columns: auto minmax(auto, 1fr) minmax(0, 72px);\n  grid-gap: 8px;\n  cursor: ",
        ";\n  pointer-events: ",
        ";\n  :hover {\n    background-color: ",
        ";\n  }\n  opacity: ",
        ";\n"
    ]);
    CurrencyList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




















function currencyKey(currency) {
    return (currency === null || currency === void 0 ? void 0 : currency.isToken) ? currency.address : (currency === null || currency === void 0 ? void 0 : currency.isNative) ? currency.symbol : "";
}
var StyledBalanceText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-9bd581ea-0"
})(CurrencyList_templateObject());
var FixedContentRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9bd581ea-1"
})(CurrencyList_templateObject1());
function Balance(param) {
    var balance = param.balance;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBalanceText, {
        title: balance.toExact(),
        children: balance.toSignificant(4)
    });
}
var MenuItem = (0,styled_components_browser_esm/* default */.ZP)(Layout_Row/* RowBetween */.m0).withConfig({
    componentId: "sc-9bd581ea-2"
})(CurrencyList_templateObject2(), function(param) {
    var disabled = param.disabled;
    return !disabled && "pointer";
}, function(param) {
    var disabled = param.disabled;
    return disabled && "none";
}, function(param) {
    var theme = param.theme, disabled = param.disabled;
    return !disabled && theme.colors.background;
}, function(param) {
    var disabled = param.disabled, selected = param.selected;
    return disabled || selected ? 0.5 : 1;
});
function CurrencyRow(param) {
    var currency = param.currency, onSelect = param.onSelect, isSelected = param.isSelected, otherSelected = param.otherSelected, style = param.style;
    var account = (0,dist/* useWeb3React */.Ge)().account;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var key = currencyKey(currency);
    var selectedTokenList = (0,hooks/* useCombinedActiveList */.z0)();
    var isOnSelectedList = (0,utils/* isTokenOnList */.wK)(selectedTokenList, currency);
    var customAdded = (0,Tokens/* useIsUserAddedToken */.EH)(currency);
    var balance = (0,wallet_hooks/* useCurrencyBalance */._h)(account !== null && account !== void 0 ? account : undefined, currency);
    // only show add or remove buttons if not on selected list
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem, {
        style: style,
        className: "token-item-".concat(key),
        onClick: function() {
            return isSelected ? null : onSelect();
        },
        disabled: isSelected,
        selected: otherSelected,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                currency: currency,
                size: "24px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.ZP, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        children: currency.symbol
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        color: "textSubtle",
                        small: true,
                        ellipsis: true,
                        maxWidth: "200px",
                        children: [
                            !isOnSelectedList && customAdded && "".concat(t("Added by user"), " •"),
                            " ",
                            currency.name
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Row/* RowFixed */.DA, {
                style: {
                    justifySelf: "flex-end"
                },
                children: balance ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance, {
                    balance: balance
                }) : account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {}) : null
            })
        ]
    });
}
function CurrencyList(param) {
    var height = param.height, currencies = param.currencies, inactiveCurrencies = param.inactiveCurrencies, selectedCurrency = param.selectedCurrency, onCurrencySelect = param.onCurrencySelect, otherCurrency = param.otherCurrency, fixedListRef = param.fixedListRef, showNative = param.showNative, showImportView = param.showImportView, setImportToken = param.setImportToken, breakIndex = param.breakIndex;
    var native = (0,useNativeCurrency/* default */.Z)();
    var itemData = (0,react.useMemo)(function() {
        var formatted = showNative ? [
            native
        ].concat((0,_to_consumable_array/* default */.Z)(currencies), (0,_to_consumable_array/* default */.Z)(inactiveCurrencies)) : (0,_to_consumable_array/* default */.Z)(currencies).concat((0,_to_consumable_array/* default */.Z)(inactiveCurrencies));
        if (breakIndex !== undefined) {
            formatted = (0,_to_consumable_array/* default */.Z)(formatted.slice(0, breakIndex)).concat([
                undefined
            ], (0,_to_consumable_array/* default */.Z)(formatted.slice(breakIndex, formatted.length)));
        }
        return formatted;
    }, [
        breakIndex,
        currencies,
        inactiveCurrencies,
        showNative,
        native
    ]);
    var chainId = (0,useActiveChainId/* useActiveChainId */.g)().chainId;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var Row = (0,react.useCallback)(function(param) {
        var data = param.data, index = param.index, style = param.style;
        var currency = data[index];
        var isSelected = Boolean(selectedCurrency && currency && selectedCurrency.equals(currency));
        var otherSelected = Boolean(otherCurrency && currency && otherCurrency.equals(currency));
        var handleSelect = function() {
            return onCurrencySelect(currency);
        };
        var token = (0,wrappedCurrency/* wrappedCurrency */.pu)(currency, chainId);
        var showImport = index > currencies.length;
        if (index === breakIndex || !data) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedContentRow, {
                style: style,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* LightGreyCard */.m5, {
                    padding: "8px 12px",
                    borderRadius: "8px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Row/* RowBetween */.m0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                small: true,
                                children: t("Expanded results from inactive Token Lists")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* QuestionHelper */.s, {
                                text: t("Tokens from inactive lists. Import specific tokens below or click 'Manage' to activate more lists."),
                                ml: "4px"
                            })
                        ]
                    })
                })
            });
        }
        if (showImport && token) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImportRow, {
                style: style,
                token: token,
                showImportView: showImportView,
                setImportToken: setImportToken,
                dim: true
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyRow, {
            style: style,
            currency: currency,
            isSelected: isSelected,
            onSelect: handleSelect,
            otherSelected: otherSelected
        });
    }, [
        selectedCurrency,
        otherCurrency,
        chainId,
        currencies.length,
        breakIndex,
        onCurrencySelect,
        t,
        showImportView,
        setImportToken, 
    ]);
    var itemKey = (0,react.useCallback)(function(index, data) {
        return currencyKey(data[index]);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FixedSizeList */.t7, {
        height: height,
        ref: fixedListRef,
        width: "100%",
        itemData: itemData,
        itemCount: itemData.length,
        itemSize: 56,
        itemKey: itemKey,
        children: Row
    });
}

;// CONCATENATED MODULE: ./src/components/SearchModal/filtering.ts



function filterTokens(tokens, search) {
    if (search.length === 0) return tokens;
    var searchingAddress = isAddress(search);
    if (searchingAddress) {
        return tokens.filter(function(token) {
            return token.address === searchingAddress;
        });
    }
    var lowerSearchParts = search.toLowerCase().split(/\s+/).filter(function(s) {
        return s.length > 0;
    });
    if (lowerSearchParts.length === 0) {
        return tokens;
    }
    var matchesSearch = function(s) {
        var sParts = s.toLowerCase().split(/\s+/).filter(function(s_) {
            return s_.length > 0;
        });
        return lowerSearchParts.every(function(p) {
            return p.length === 0 || sParts.some(function(sp) {
                return sp.startsWith(p) || sp.endsWith(p);
            });
        });
    };
    return tokens.filter(function(token) {
        var symbol = token.symbol, name = token.name;
        return symbol && matchesSearch(symbol) || name && matchesSearch(name);
    });
}
function createFilterToken(search) {
    var searchingAddress = (0,utils/* isAddress */.UJ)(search);
    if (searchingAddress) {
        var address = searchingAddress.toLowerCase();
        return function(t) {
            return "address" in t && address === t.address.toLowerCase();
        };
    }
    var lowerSearchParts = search.toLowerCase().split(/\s+/).filter(function(s) {
        return s.length > 0;
    });
    if (lowerSearchParts.length === 0) {
        return function() {
            return true;
        };
    }
    var matchesSearch = function(s) {
        var sParts = s.toLowerCase().split(/\s+/).filter(function(s_) {
            return s_.length > 0;
        });
        return lowerSearchParts.every(function(p) {
            return p.length === 0 || sParts.some(function(sp) {
                return sp.startsWith(p) || sp.endsWith(p);
            });
        });
    };
    return function(token) {
        var symbol = token.symbol, name = token.name;
        return symbol && matchesSearch(symbol) || name && matchesSearch(name);
    };
}
function useSortedTokensByQuery(tokens, searchQuery) {
    return (0,react.useMemo)(function() {
        if (!tokens) {
            return [];
        }
        var trimmedSearchQuery = searchQuery.toLowerCase().trim();
        var symbolMatch = trimmedSearchQuery.split(/\s+/).filter(function(s) {
            return s.length > 0;
        });
        if (symbolMatch.length > 1) {
            return tokens;
        }
        var exactMatches = [];
        var symbolSubstrings = [];
        var rest = [];
        // sort tokens by exact match -> substring on symbol match -> rest
        tokens.forEach(function(token) {
            var ref, ref1;
            var tokenSymbol = (ref = token.symbol) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            if (tokenSymbol === symbolMatch[0] || ((ref1 = token.name) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === trimmedSearchQuery) {
                return exactMatches.push(token);
            }
            if (tokenSymbol.startsWith(trimmedSearchQuery)) {
                return symbolSubstrings.push(token);
            }
            return rest.push(token);
        });
        return (0,_to_consumable_array/* default */.Z)(exactMatches).concat((0,_to_consumable_array/* default */.Z)(symbolSubstrings), (0,_to_consumable_array/* default */.Z)(rest));
    }, [
        tokens,
        searchQuery
    ]);
}

;// CONCATENATED MODULE: ./src/components/SearchModal/sorting.ts


// compare two token amounts with highest one coming first
function balanceComparator(balanceA, balanceB) {
    if (balanceA && balanceB) {
        return balanceA.greaterThan(balanceB) ? -1 : balanceA.equalTo(balanceB) ? 0 : 1;
    }
    if (balanceA && balanceA.greaterThan("0")) {
        return -1;
    }
    if (balanceB && balanceB.greaterThan("0")) {
        return 1;
    }
    return 0;
}
function getTokenComparator(balances) {
    return function sortTokens(tokenA, tokenB) {
        // -1 = a is first
        // 1 = b is first
        // sort by balances
        var balanceA = balances[tokenA.address];
        var balanceB = balances[tokenB.address];
        var balanceComp = balanceComparator(balanceA, balanceB);
        if (balanceComp !== 0) return balanceComp;
        if (tokenA.symbol && tokenB.symbol) {
            // sort by symbol
            return tokenA.symbol.toLowerCase() < tokenB.symbol.toLowerCase() ? -1 : 1;
        }
        return tokenA.symbol ? -1 : tokenB.symbol ? -1 : 0;
    };
}
function useTokenComparator(inverted) {
    var balances = (0,wallet_hooks/* useAllTokenBalances */.uD)();
    var comparator = (0,react.useMemo)(function() {
        return getTokenComparator(balances !== null && balances !== void 0 ? balances : {});
    }, [
        balances
    ]);
    return (0,react.useMemo)(function() {
        if (inverted) {
            return function(tokenA, tokenB) {
                return comparator(tokenA, tokenB) * -1;
            };
        }
        return comparator;
    }, [
        inverted,
        comparator
    ]);
}
/* harmony default export */ var sorting = (useTokenComparator);

;// CONCATENATED MODULE: ./src/components/SearchModal/swapSound.ts
var swapSound;
var swapSoundURL = "https://cdn.pancakeswap.com/swap.mp3";
var getSwapSound = function() {
    if (!swapSound) {
        swapSound = new Audio(swapSoundURL);
    }
    return swapSound;
};

;// CONCATENATED MODULE: ./src/components/SearchModal/CurrencySearch.tsx
/* eslint-disable no-restricted-syntax */ 





















function useSearchInactiveTokenLists(search) {
    var minResults = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    var lists = (0,hooks/* useAllLists */.R0)();
    var inactiveUrls = (0,hooks/* useInactiveListUrls */.eu)();
    var chainId = (0,useActiveChainId/* useActiveChainId */.g)().chainId;
    var activeTokens = (0,Tokens/* useAllTokens */.e_)();
    return (0,react.useMemo)(function() {
        if (!search || search.trim().length === 0) return [];
        var filterToken = createFilterToken(search);
        var exactMatches = [];
        var rest = [];
        var addressSet = {};
        var trimmedSearchQuery = search.toLowerCase().trim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = inactiveUrls[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var url = _step.value;
                var list = lists[url].current;
                // eslint-disable-next-line no-continue
                if (!list) continue;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = list.tokens[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var tokenInfo = _step1.value;
                        if (tokenInfo.chainId === chainId && !(tokenInfo.address in activeTokens) && !addressSet[tokenInfo.address] && filterToken(tokenInfo)) {
                            var ref, ref1;
                            var wrapped = new token_lists_src/* WrappedTokenInfo */.DT(tokenInfo);
                            addressSet[wrapped.address] = true;
                            if (((ref = tokenInfo.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === trimmedSearchQuery || ((ref1 = tokenInfo.symbol) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === trimmedSearchQuery) {
                                exactMatches.push(wrapped);
                            } else {
                                rest.push(wrapped);
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return (0,_to_consumable_array/* default */.Z)(exactMatches).concat((0,_to_consumable_array/* default */.Z)(rest)).slice(0, minResults);
    }, [
        activeTokens,
        chainId,
        inactiveUrls,
        lists,
        minResults,
        search
    ]);
}
function CurrencySearch(param) {
    var selectedCurrency = param.selectedCurrency, onCurrencySelect = param.onCurrencySelect, otherSelectedCurrency = param.otherSelectedCurrency, showCommonBases = param.showCommonBases, commonBasesType = param.commonBasesType, showImportView = param.showImportView, setImportToken = param.setImportToken, height = param.height;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var chainId = (0,useActiveChainId/* useActiveChainId */.g)().chainId;
    // refs for fixed size lists
    var fixedList = (0,react.useRef)();
    var ref = (0,react.useState)(""), searchQuery = ref[0], setSearchQuery = ref[1];
    var debouncedQuery = (0,src/* useDebounce */.Nr)(searchQuery, 200);
    var ref1 = (0,react.useState)(false), invertSearchOrder = ref1[0];
    var allTokens = (0,Tokens/* useAllTokens */.e_)();
    // if they input an address, use it
    var searchToken = (0,Tokens/* useToken */.dQ)(debouncedQuery);
    var searchTokenIsAdded = (0,Tokens/* useIsUserAddedToken */.EH)(searchToken);
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useAudioModeManager */.TO)(), 1), audioPlay = ref2[0];
    var native = (0,useNativeCurrency/* default */.Z)();
    var showNative = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        var s = debouncedQuery.toLowerCase().trim();
        return native && ((ref = native.symbol) === null || ref === void 0 ? void 0 : (ref1 = ref.toLowerCase) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.call(ref)) === null || ref2 === void 0 ? void 0 : ref2.indexOf(s)) !== -1;
    }, [
        debouncedQuery,
        native
    ]);
    var filteredTokens = (0,react.useMemo)(function() {
        var filterToken = createFilterToken(debouncedQuery);
        return Object.values(allTokens).filter(filterToken);
    }, [
        allTokens,
        debouncedQuery
    ]);
    var filteredQueryTokens = useSortedTokensByQuery(filteredTokens, debouncedQuery);
    var tokenComparator = sorting(invertSearchOrder);
    var filteredSortedTokens = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(filteredQueryTokens).sort(tokenComparator);
    }, [
        filteredQueryTokens,
        tokenComparator
    ]);
    var handleCurrencySelect = (0,react.useCallback)(function(currency) {
        onCurrencySelect(currency);
        if (audioPlay) {
            getSwapSound().play();
        }
    }, [
        audioPlay,
        onCurrencySelect
    ]);
    // manage focus on modal show
    var inputRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        if (!isMobile) inputRef.current.focus();
    }, [
        isMobile
    ]);
    var handleInput = (0,react.useCallback)(function(event) {
        var ref;
        var input = event.target.value;
        var checksummedInput = (0,utils/* isAddress */.UJ)(input);
        setSearchQuery(checksummedInput || input);
        (ref = fixedList.current) === null || ref === void 0 ? void 0 : ref.scrollTo(0);
    }, []);
    var handleEnter = (0,react.useCallback)(function(e) {
        if (e.key === "Enter") {
            var s = debouncedQuery.toLowerCase().trim();
            if (s === native.symbol.toLowerCase().trim()) {
                handleCurrencySelect(native);
            } else if (filteredSortedTokens.length > 0) {
                var ref;
                if (((ref = filteredSortedTokens[0].symbol) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === debouncedQuery.trim().toLowerCase() || filteredSortedTokens.length === 1) {
                    handleCurrencySelect(filteredSortedTokens[0]);
                }
            }
        }
    }, [
        debouncedQuery,
        filteredSortedTokens,
        handleCurrencySelect,
        native
    ]);
    // if no results on main list, show option to expand into inactive
    var filteredInactiveTokens = useSearchInactiveTokenLists(debouncedQuery);
    var hasFilteredInactiveTokens = Boolean(filteredInactiveTokens === null || filteredInactiveTokens === void 0 ? void 0 : filteredInactiveTokens.length);
    var getCurrencyListRows = (0,react.useCallback)(function() {
        if (searchToken && !searchTokenIsAdded && !hasFilteredInactiveTokens) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.ZP, {
                style: {
                    padding: "20px 0",
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImportRow, {
                    token: searchToken,
                    showImportView: showImportView,
                    setImportToken: setImportToken
                })
            });
        }
        return Boolean(filteredSortedTokens === null || filteredSortedTokens === void 0 ? void 0 : filteredSortedTokens.length) || hasFilteredInactiveTokens ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            margin: "24px -24px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyList, {
                height: isMobile ? showCommonBases ? height || 250 : height ? height + 80 : 350 : 390,
                showNative: showNative,
                currencies: filteredSortedTokens,
                inactiveCurrencies: filteredInactiveTokens,
                breakIndex: Boolean(filteredInactiveTokens === null || filteredInactiveTokens === void 0 ? void 0 : filteredInactiveTokens.length) && filteredSortedTokens ? filteredSortedTokens.length : undefined,
                onCurrencySelect: handleCurrencySelect,
                otherCurrency: otherSelectedCurrency,
                selectedCurrency: selectedCurrency,
                fixedListRef: fixedList,
                showImportView: showImportView,
                setImportToken: setImportToken
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.ZP, {
            style: {
                padding: "20px",
                height: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                textAlign: "center",
                mb: "20px",
                children: t("No results found.")
            })
        });
    }, [
        filteredInactiveTokens,
        filteredSortedTokens,
        handleCurrencySelect,
        hasFilteredInactiveTokens,
        otherSelectedCurrency,
        searchToken,
        searchTokenIsAdded,
        selectedCurrency,
        setImportToken,
        showNative,
        showImportView,
        t,
        showCommonBases,
        isMobile,
        height, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Row/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "token-search-input",
                            placeholder: t("Search name or paste address"),
                            scale: "lg",
                            autoComplete: "off",
                            value: searchQuery,
                            ref: inputRef,
                            onChange: handleInput,
                            onKeyDown: handleEnter
                        })
                    }),
                    showCommonBases && /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonBases, {
                        chainId: chainId,
                        onSelect: handleCurrencySelect,
                        selectedCurrency: selectedCurrency,
                        commonBasesType: commonBasesType
                    })
                ]
            }),
            getCurrencyListRows()
        ]
    });
}
/* harmony default export */ var SearchModal_CurrencySearch = (CurrencySearch);

// EXTERNAL MODULE: ./src/components/SearchModal/ImportToken.tsx
var ImportToken = __webpack_require__(95940);
// EXTERNAL MODULE: ../../packages/uikit/src/components/ButtonMenu/ButtonMenu.tsx
var ButtonMenu = __webpack_require__(2448);
// EXTERNAL MODULE: ../../packages/uikit/src/components/ButtonMenu/ButtonMenuItem.tsx
var ButtonMenuItem = __webpack_require__(97984);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(98813);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(35378);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/Cog.tsx
var Cog = __webpack_require__(46178);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Toggle/Toggle.tsx + 2 modules
var Toggle = __webpack_require__(46098);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/Checkmark.tsx
var Checkmark = __webpack_require__(53274);
// EXTERNAL MODULE: ./src/config/constants/lists.ts
var constants_lists = __webpack_require__(7964);
// EXTERNAL MODULE: ../../node_modules/jotai/esm/index.mjs
var esm = __webpack_require__(72978);
// EXTERNAL MODULE: ./src/state/lists/lists.ts
var lists_lists = __webpack_require__(50222);
// EXTERNAL MODULE: ../../packages/utils/uriToHttp.ts
var uriToHttp = __webpack_require__(12241);
;// CONCATENATED MODULE: ./src/components/SearchModal/ManageLists.tsx




function ManageLists_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n"
    ]);
    ManageLists_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ManageLists_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border: solid 1px;\n  border-color: ",
        ";\n  transition: 200ms;\n  align-items: center;\n  padding: 1rem;\n  border-radius: 20px;\n  opacity: ",
        ";\n"
    ]);
    ManageLists_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ManageLists_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1rem 0;\n  height: 100%;\n  overflow: auto;\n"
    ]);
    ManageLists_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

















function listVersionLabel(version) {
    return "v".concat(version.major, ".").concat(version.minor, ".").concat(version.patch);
}
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Column/* default */.ZP).withConfig({
    componentId: "sc-87a0f84e-0"
})(ManageLists_templateObject());
var ManageLists_RowWrapper = (0,styled_components_browser_esm/* default */.ZP)(Layout_Row/* default */.ZP).withConfig({
    componentId: "sc-87a0f84e-1"
})(ManageLists_templateObject1(), function(param) {
    var active = param.active, theme = param.theme;
    return active ? "".concat(theme.colors.success19) : "transparent";
}, function(param) {
    var active = param.active, theme = param.theme;
    return active ? theme.colors.success : theme.colors.tertiary;
}, function(param) {
    var hasActiveTokens = param.hasActiveTokens;
    return hasActiveTokens ? 1 : 0.4;
});
function listUrlRowHTMLId(listUrl) {
    return "list-row-".concat(listUrl.replace(/\./g, "-"));
}
var ListRow = /*#__PURE__*/ (0,react.memo)(function ListRow(param) {
    var listUrl = param.listUrl;
    var chainId = (0,useActiveChainId/* useActiveChainId */.g)().chainId;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isActive = (0,hooks/* useIsListActive */.EF)(listUrl);
    var listsByUrl = (0,esm/* useAtomValue */.Dv)(hooks/* selectorByUrlsAtom */.Ti);
    var ref = (0,_sliced_to_array/* default */.Z)((0,lists_lists/* useListState */.n)(), 2), dispatch = ref[1];
    var _listUrl = listsByUrl[listUrl], list = _listUrl.current, pending = _listUrl.pendingUpdate;
    var activeTokensOnThisChain = (0,react.useMemo)(function() {
        if (!list || !chainId) {
            return 0;
        }
        return list.tokens.reduce(function(acc, cur) {
            return cur.chainId === chainId ? acc + 1 : acc;
        }, 0);
    }, [
        chainId,
        list
    ]);
    var handleAcceptListUpdate = (0,react.useCallback)(function() {
        if (!pending) return;
        dispatch((0,token_lists_src/* acceptListUpdate */.xJ)(listUrl));
    }, [
        dispatch,
        listUrl,
        pending
    ]);
    var handleRemoveList = (0,react.useCallback)(function() {
        // eslint-disable-next-line no-alert
        if (window.confirm("Please confirm you would like to remove this list")) {
            dispatch((0,token_lists_src/* removeList */.J_)(listUrl));
        }
    }, [
        dispatch,
        listUrl
    ]);
    var handleEnableList = (0,react.useCallback)(function() {
        dispatch((0,token_lists_src/* enableList */.ic)(listUrl));
    }, [
        dispatch,
        listUrl
    ]);
    var handleDisableList = (0,react.useCallback)(function() {
        dispatch((0,token_lists_src/* disableList */.K$)(listUrl));
    }, [
        dispatch,
        listUrl
    ]);
    var ref1 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: list && listVersionLabel(list.version)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                external: true,
                href: "https://tokenlists.org/token-list?url=".concat(listUrl),
                children: t("See")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "danger",
                scale: "xs",
                onClick: handleRemoveList,
                disabled: Object.keys(listsByUrl).length === 1,
                children: t("Remove")
            }),
            pending && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "text",
                onClick: handleAcceptListUpdate,
                style: {
                    fontSize: "12px"
                },
                children: t("Update list")
            })
        ]
    }), {
        placement: "right-end",
        trigger: "click"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    if (!list) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ManageLists_RowWrapper, {
        active: isActive,
        hasActiveTokens: activeTokensOnThisChain > 0,
        id: listUrlRowHTMLId(listUrl),
        children: [
            tooltipVisible && tooltip,
            list.logoURI ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* ListLogo */._r, {
                size: "40px",
                style: {
                    marginRight: "1rem"
                },
                logoURI: list.logoURI,
                alt: "".concat(list.name, " list logo")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    width: "24px",
                    height: "24px",
                    marginRight: "1rem"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.ZP, {
                style: {
                    flex: "1"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Row/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            bold: true,
                            children: list.name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Row/* RowFixed */.DA, {
                        mt: "4px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: "12px",
                                mr: "6px",
                                textTransform: "lowercase",
                                children: [
                                    list.tokens.length,
                                    " ",
                                    t("Tokens")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                ref: targetRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cog/* default */.Z, {
                                    color: "text",
                                    width: "12px"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle/* default */.Z, {
                checked: isActive,
                onChange: function() {
                    if (isActive) {
                        handleDisableList();
                    } else {
                        handleEnableList();
                    }
                }
            })
        ]
    }, listUrl);
});
var ListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87a0f84e-2"
})(ManageLists_templateObject2());
function ManageLists(param) {
    var setModalView = param.setModalView, setImportList = param.setImportList, setListUrl = param.setListUrl;
    var ref = (0,react.useState)(""), listUrlInput = ref[0], setListUrlInput = ref[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,lists_lists/* useListState */.n)(), 2), dispatch = ref1[1];
    var lists = (0,hooks/* useAllLists */.R0)();
    // sort by active but only if not visible
    var activeListUrls = (0,hooks/* useActiveListUrls */.v0)();
    var ref2 = (0,react.useState)(), activeCopy = ref2[0], setActiveCopy = ref2[1];
    (0,react.useEffect)(function() {
        if (!activeCopy && activeListUrls) {
            setActiveCopy(activeListUrls);
        }
    }, [
        activeCopy,
        activeListUrls
    ]);
    var handleInput = (0,react.useCallback)(function(e) {
        setListUrlInput(e.target.value);
    }, []);
    var fetchList = (0,token_lists_src/* useFetchListCallback */.jn)(dispatch);
    var validUrl = (0,react.useMemo)(function() {
        return (0,uriToHttp/* default */.Z)(listUrlInput).length > 0;
    }, [
        listUrlInput
    ]);
    var sortedLists = (0,react.useMemo)(function() {
        var listUrls = Object.keys(lists);
        return listUrls.filter(function(listUrl) {
            // only show loaded lists, hide unsupported lists
            return Boolean(lists[listUrl].current) && !constants_lists/* UNSUPPORTED_LIST_URLS.includes */.US.includes(listUrl);
        }).sort(function(u1, u2) {
            var _u1 = lists[u1], l1 = _u1.current;
            var _u2 = lists[u2], l2 = _u2.current;
            // first filter on active lists
            if ((activeCopy === null || activeCopy === void 0 ? void 0 : activeCopy.includes(u1)) && !(activeCopy === null || activeCopy === void 0 ? void 0 : activeCopy.includes(u2))) {
                return -1;
            }
            if (!(activeCopy === null || activeCopy === void 0 ? void 0 : activeCopy.includes(u1)) && (activeCopy === null || activeCopy === void 0 ? void 0 : activeCopy.includes(u2))) {
                return 1;
            }
            if (l1 && l2) {
                // Always make PancakeSwap list in top.
                var keyword = "pancakeswap";
                if (l1.name.toLowerCase().includes(keyword) || l2.name.toLowerCase().includes(keyword)) {
                    return -1;
                }
                return l1.name.toLowerCase() < l2.name.toLowerCase() ? -1 : l1.name.toLowerCase() === l2.name.toLowerCase() ? 0 : 1;
            }
            if (l1) return -1;
            if (l2) return 1;
            return 0;
        });
    }, [
        lists,
        activeCopy
    ]);
    // temporary fetched list for import flow
    var ref3 = (0,react.useState)(), tempList = ref3[0], setTempList = ref3[1];
    var ref4 = (0,react.useState)(), addError = ref4[0], setAddError = ref4[1];
    (0,react.useEffect)(function() {
        function fetchTempList() {
            return _fetchTempList.apply(this, arguments);
        }
        function _fetchTempList() {
            _fetchTempList = (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    fetchList(listUrlInput, false).then(function(list) {
                        return setTempList(list);
                    }).catch(function() {
                        return setAddError("Error importing list");
                    });
                    return [
                        2
                    ];
                });
            });
            return _fetchTempList.apply(this, arguments);
        }
        // if valid url, fetch details for card
        if (validUrl) {
            fetchTempList();
        } else {
            setTempList(undefined);
            if (listUrlInput !== "") {
                setAddError("Enter valid list location");
            }
        }
        // reset error
        if (listUrlInput === "") {
            setAddError(undefined);
        }
    }, [
        fetchList,
        listUrlInput,
        validUrl
    ]);
    // check if list is already imported
    var isImported = Object.keys(lists).includes(listUrlInput);
    // set list values and have parent modal switch to import list view
    var handleImport = (0,react.useCallback)(function() {
        if (!tempList) return;
        setImportList(tempList);
        setModalView(types/* CurrencyModalView.importList */.Hv.importList);
        setListUrl(listUrlInput);
    }, [
        listUrlInput,
        setImportList,
        setListUrl,
        setModalView,
        tempList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                gap: "14px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Row/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "list-add-input",
                            scale: "lg",
                            placeholder: t("https:// or ipfs://"),
                            value: listUrlInput,
                            onChange: handleInput
                        })
                    }),
                    addError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "failure",
                        style: {
                            textOverflow: "ellipsis",
                            overflow: "hidden"
                        },
                        children: addError
                    }) : null
                ]
            }),
            tempList && /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                style: {
                    paddingTop: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.ZP, {
                    padding: "12px 20px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Row/* RowBetween */.m0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Row/* RowFixed */.DA, {
                                children: [
                                    tempList.logoURI && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* ListLogo */._r, {
                                        logoURI: tempList.logoURI,
                                        size: "40px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                                        gap: "4px",
                                        style: {
                                            marginLeft: "20px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                bold: true,
                                                children: tempList.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                color: "textSubtle",
                                                small: true,
                                                textTransform: "lowercase",
                                                children: [
                                                    tempList.tokens.length,
                                                    " ",
                                                    t("Tokens")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isImported ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Row/* RowFixed */.DA, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {
                                        width: "16px",
                                        mr: "10px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: t("Loaded")
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                width: "fit-content",
                                onClick: handleImport,
                                children: t("Import")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                    gap: "md",
                    children: sortedLists.map(function(listUrl) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListRow, {
                            listUrl: listUrl
                        }, listUrl);
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var SearchModal_ManageLists = (ManageLists);

// EXTERNAL MODULE: ../../packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(73697);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(93058);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/Close.tsx
var Close = __webpack_require__(54231);
// EXTERNAL MODULE: ./src/state/user/hooks/useUserAddedTokens.ts
var useUserAddedTokens = __webpack_require__(18534);
;// CONCATENATED MODULE: ./src/components/SearchModal/ManageTokens.tsx

function ManageTokens_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: calc(100% - 60px);\n  position: relative;\n  padding-bottom: 60px;\n"
    ]);
    ManageTokens_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ManageTokens_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    ManageTokens_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var ManageTokens_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3f8c72a8-0"
})(ManageTokens_templateObject());
var Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3f8c72a8-1"
})(ManageTokens_templateObject1());
function ManageTokens(param) {
    var setModalView = param.setModalView, setImportToken = param.setImportToken;
    var chainId = (0,useActiveChainId/* useActiveChainId */.g)().chainId;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(""), searchQuery = ref[0], setSearchQuery = ref[1];
    // manage focus on modal show
    var inputRef = (0,react.useRef)();
    var handleInput = (0,react.useCallback)(function(event) {
        var input = event.target.value;
        var checksummedInput = (0,utils/* isAddress */.UJ)(input);
        setSearchQuery(checksummedInput || input);
    }, []);
    // if they input an address, use it
    var searchToken = (0,Tokens/* useToken */.dQ)(searchQuery);
    // all tokens for local list
    var userAddedTokens = (0,useUserAddedTokens/* default */.Z)();
    var removeToken = (0,user_hooks/* useRemoveUserAddedToken */.QG)();
    var handleRemoveAll = (0,react.useCallback)(function() {
        if (chainId && userAddedTokens) {
            userAddedTokens.forEach(function(token) {
                return removeToken(chainId, token.address);
            });
        }
    }, [
        removeToken,
        userAddedTokens,
        chainId
    ]);
    var tokenList = (0,react.useMemo)(function() {
        return chainId && userAddedTokens.map(function(token) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Row/* RowBetween */.m0, {
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Row/* RowFixed */.DA, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                currency: token,
                                size: "20px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                external: true,
                                href: (0,utils/* getBlockExploreLink */.C)(token.address, "address", chainId),
                                color: "textSubtle",
                                ml: "10px",
                                children: token.symbol
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Row/* RowFixed */.DA, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                variant: "text",
                                onClick: function() {
                                    return removeToken(chainId, token.address);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                                href: (0,utils/* getBlockExploreLink */.C)(token.address, "address", chainId)
                            })
                        ]
                    })
                ]
            }, token.address);
        });
    }, [
        userAddedTokens,
        chainId,
        removeToken
    ]);
    var isAddressValid = searchQuery === "" || (0,utils/* isAddress */.UJ)(searchQuery);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ManageTokens_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.ZP, {
            style: {
                width: "100%",
                flex: "1 1"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    gap: "14px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Row/* default */.ZP, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                id: "token-search-input",
                                scale: "lg",
                                placeholder: "0x0000",
                                value: searchQuery,
                                autoComplete: "off",
                                ref: inputRef,
                                onChange: handleInput,
                                isWarning: !isAddressValid
                            })
                        }),
                        !isAddressValid && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "failure",
                            children: t("Enter valid token address")
                        }),
                        searchToken && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImportRow, {
                            token: searchToken,
                            showImportView: function() {
                                return setModalView(types/* CurrencyModalView.importToken */.Hv.importToken);
                            },
                            setImportToken: setImportToken,
                            style: {
                                height: "fit-content"
                            }
                        })
                    ]
                }),
                tokenList,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            bold: true,
                            color: "textSubtle",
                            children: [
                                userAddedTokens === null || userAddedTokens === void 0 ? void 0 : userAddedTokens.length,
                                " ",
                                userAddedTokens.length === 1 ? t("Custom Token") : t("Custom Tokens")
                            ]
                        }),
                        userAddedTokens.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "tertiary",
                            onClick: handleRemoveAll,
                            children: t("Clear all")
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/SearchModal/Manage.tsx

function Manage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    Manage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledButtonMenu = (0,styled_components_browser_esm/* default */.ZP)(ButtonMenu/* default */.Z).withConfig({
    componentId: "sc-e2a99e21-0"
})(Manage_templateObject());
function Manage(param) {
    var setModalView = param.setModalView, setImportList = param.setImportList, setImportToken = param.setImportToken, setListUrl = param.setListUrl;
    var ref = (0,react.useState)(true), showLists = ref[0], setShowLists = ref[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalBody */.fe, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButtonMenu, {
                activeIndex: showLists ? 0 : 1,
                onItemClick: function() {
                    return setShowLists(function(prev) {
                        return !prev;
                    });
                },
                scale: "sm",
                variant: "subtle",
                mb: "32px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                        width: "50%",
                        children: t("Lists")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                        width: "50%",
                        children: t("Tokens")
                    })
                ]
            }),
            showLists ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModal_ManageLists, {
                setModalView: setModalView,
                setImportList: setImportList,
                setListUrl: setListUrl
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ManageTokens, {
                setModalView: setModalView,
                setImportToken: setImportToken
            })
        ]
    });
}

// EXTERNAL MODULE: ../../packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(76660);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(76903);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(7887);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(19081);
;// CONCATENATED MODULE: ./src/components/SearchModal/ImportList.tsx


function ImportList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n"
    ]);
    ImportList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ImportList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 3px;\n  width: 3px;\n  background-color: ",
        ";\n  border-radius: 50%;\n"
    ]);
    ImportList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var ImportList_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54d8c46d-0"
})(ImportList_templateObject());
var TextDot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-54d8c46d-1"
})(ImportList_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
function ImportList(param) {
    var listURL = param.listURL, list = param.list, onImport = param.onImport;
    var ref;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,lists_lists/* useListState */.n)(), 2), dispatch = ref1[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    // user must accept
    var ref2 = (0,react.useState)(false), confirmed = ref2[0], setConfirmed = ref2[1];
    var lists = (0,hooks/* useAllLists */.R0)();
    var fetchList = (0,token_lists_src/* useFetchListCallback */.jn)(dispatch);
    // monitor is list is loading
    var adding = Boolean((ref = lists[listURL]) === null || ref === void 0 ? void 0 : ref.loadingRequestId);
    var ref3 = (0,react.useState)(null), addError = ref3[0], setAddError = ref3[1];
    var handleAddList = (0,react.useCallback)(function() {
        if (adding) return;
        setAddError(null);
        fetchList(listURL).then(function() {
            dispatch((0,token_lists_src/* enableList */.ic)(listURL));
            onImport();
        }).catch(function(error) {
            setAddError(error.message);
            dispatch((0,token_lists_src/* removeList */.J_)(listURL));
        });
    }, [
        adding,
        dispatch,
        fetchList,
        listURL,
        onImport
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImportList_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
            gap: "md",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                gap: "md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.ZP, {
                        padding: "12px 20px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Row/* RowBetween */.m0, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Row/* RowFixed */.DA, {
                                children: [
                                    list.logoURI && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* ListLogo */._r, {
                                        logoURI: list.logoURI,
                                        size: "40px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                                        gap: "sm",
                                        style: {
                                            marginLeft: "20px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Row/* RowFixed */.DA, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        bold: true,
                                                        mr: "6px",
                                                        children: list.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextDot, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        small: true,
                                                        color: "textSubtle",
                                                        ml: "6px",
                                                        children: [
                                                            list.tokens.length,
                                                            " tokens"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                small: true,
                                                external: true,
                                                ellipsis: true,
                                                maxWidth: "90%",
                                                href: "https://tokenlists.org/token-list?url=".concat(listURL),
                                                children: listURL
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                        variant: "danger",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "20px",
                                    textAlign: "center",
                                    color: theme.colors.failure,
                                    mb: "16px",
                                    children: t("Import at your own risk")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: theme.colors.failure,
                                    mb: "8px",
                                    children: t("By adding this list you are implicitly trusting that the data is correct. Anyone can create a list, including creating fake versions of existing lists and lists that claim to represent projects that do not have one.")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    color: theme.colors.failure,
                                    mb: "16px",
                                    children: t("If you purchase a token from this list, you may not be able to sell it back.")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            name: "confirmed",
                                            type: "checkbox",
                                            checked: confirmed,
                                            onChange: function() {
                                                return setConfirmed(!confirmed);
                                            },
                                            scale: "sm"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            ml: "10px",
                                            style: {
                                                userSelect: "none"
                                            },
                                            children: t("I understand")
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: !confirmed,
                        onClick: handleAddList,
                        children: t("Import")
                    }),
                    addError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "failure",
                        style: {
                            textOverflow: "ellipsis",
                            overflow: "hidden"
                        },
                        children: addError
                    }) : null
                ]
            })
        })
    });
}
/* harmony default export */ var SearchModal_ImportList = (ImportList);

;// CONCATENATED MODULE: ./src/components/SearchModal/CurrencySearchModal.tsx


function CurrencySearchModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background-color: ",
        ";\n  text-align: center;\n"
    ]);
    CurrencySearchModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CurrencySearchModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-width: 320px;\n  max-width: 420px !important;\n  min-height: calc(var(--vh, 1vh) * 90);\n  ",
        " {\n    min-height: auto;\n  }\n"
    ]);
    CurrencySearchModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CurrencySearchModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  overflow-y: auto;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    CurrencySearchModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var CurrencySearchModal_Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-15102242-0"
})(CurrencySearchModal_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var StyledModalContainer = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalContainer */.F0).withConfig({
    componentId: "sc-15102242-1"
})(CurrencySearchModal_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var StyledModalBody = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalBody */.fe).withConfig({
    componentId: "sc-15102242-2"
})(CurrencySearchModal_templateObject2());
function CurrencySearchModal(param) {
    var _onDismiss = param.onDismiss, onDismiss = _onDismiss === void 0 ? function() {
        return null;
    } : _onDismiss, onCurrencySelect = param.onCurrencySelect, selectedCurrency = param.selectedCurrency, otherSelectedCurrency = param.otherSelectedCurrency, _showCommonBases = param.showCommonBases, showCommonBases = _showCommonBases === void 0 ? true : _showCommonBases, commonBasesType = param.commonBasesType;
    var ref = (0,react.useState)(types/* CurrencyModalView.search */.Hv.search), modalView = ref[0], setModalView = ref[1];
    var handleCurrencySelect = (0,react.useCallback)(function(currency) {
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
        onCurrencySelect(currency);
    }, [
        onDismiss,
        onCurrencySelect
    ]);
    // for token import view
    var prevView = (0,src/* usePreviousValue */.zP)(modalView);
    // used for import token flow
    var ref1 = (0,react.useState)(), importToken = ref1[0], setImportToken = ref1[1];
    // used for import list
    var ref2 = (0,react.useState)(), importList = ref2[0], setImportList = ref2[1];
    var ref3 = (0,react.useState)(), listURL = ref3[0], setListUrl = ref3[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var _obj;
    var config = (_obj = {}, (0,_define_property/* default */.Z)(_obj, types/* CurrencyModalView.search */.Hv.search, {
        title: t("Select a Token"),
        onBack: undefined
    }), (0,_define_property/* default */.Z)(_obj, types/* CurrencyModalView.manage */.Hv.manage, {
        title: t("Manage"),
        onBack: function() {
            return setModalView(types/* CurrencyModalView.search */.Hv.search);
        }
    }), (0,_define_property/* default */.Z)(_obj, types/* CurrencyModalView.importToken */.Hv.importToken, {
        title: t("Import Tokens"),
        onBack: function() {
            return setModalView(prevView && prevView !== types/* CurrencyModalView.importToken */.Hv.importToken ? prevView : types/* CurrencyModalView.search */.Hv.search);
        }
    }), (0,_define_property/* default */.Z)(_obj, types/* CurrencyModalView.importList */.Hv.importList, {
        title: t("Import List"),
        onBack: function() {
            return setModalView(types/* CurrencyModalView.search */.Hv.search);
        }
    }), _obj);
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var wrapperRef = (0,react.useRef)(null);
    var ref4 = (0,react.useState)(undefined), height = ref4[0], setHeight = ref4[1];
    (0,react.useEffect)(function() {
        if (!wrapperRef.current) return;
        setHeight(wrapperRef.current.offsetHeight - 330);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModalContainer, {
        drag: isMobile ? "y" : false,
        dragConstraints: {
            top: 0,
            bottom: 600
        },
        dragElastic: {
            top: 0
        },
        dragSnapToOrigin: true,
        onDragStart: function() {
            if (wrapperRef.current) wrapperRef.current.style.animation = "none";
        },
        // @ts-ignore
        onDragEnd: function(e, info) {
            if (info.velocity.y > Modal/* MODAL_SWIPE_TO_CLOSE_VELOCITY */.dl && onDismiss) onDismiss();
        },
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalHeader */.xB, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalTitle */.r6, {
                        children: [
                            config[modalView].onBack && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalBackButton */.vy, {
                                onBack: config[modalView].onBack
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                children: config[modalView].title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalCloseButton */.ol, {
                        onDismiss: onDismiss
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModalBody, {
                children: [
                    modalView === types/* CurrencyModalView.search */.Hv.search ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModal_CurrencySearch, {
                        onCurrencySelect: handleCurrencySelect,
                        selectedCurrency: selectedCurrency,
                        otherSelectedCurrency: otherSelectedCurrency,
                        showCommonBases: showCommonBases,
                        commonBasesType: commonBasesType,
                        showImportView: function() {
                            return setModalView(types/* CurrencyModalView.importToken */.Hv.importToken);
                        },
                        setImportToken: setImportToken,
                        height: height
                    }) : modalView === types/* CurrencyModalView.importToken */.Hv.importToken && importToken ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImportToken/* default */.Z, {
                        tokens: [
                            importToken
                        ],
                        handleCurrencySelect: handleCurrencySelect
                    }) : modalView === types/* CurrencyModalView.importList */.Hv.importList && importList && listURL ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModal_ImportList, {
                        list: importList,
                        listURL: listURL,
                        onImport: function() {
                            return setModalView(types/* CurrencyModalView.manage */.Hv.manage);
                        }
                    }) : modalView === types/* CurrencyModalView.manage */.Hv.manage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Manage, {
                        setModalView: setModalView,
                        setImportToken: setImportToken,
                        setImportList: setImportList,
                        setListUrl: setListUrl
                    }) : "",
                    modalView === types/* CurrencyModalView.search */.Hv.search && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySearchModal_Footer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            scale: "sm",
                            variant: "text",
                            onClick: function() {
                                return setModalView(types/* CurrencyModalView.manage */.Hv.manage);
                            },
                            className: "list-token-manage-button",
                            children: t("Manage Tokens")
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 95940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90902);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(76660);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(89495);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5917);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(57432);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(33441);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(76903);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(73697);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(7887);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(48608);
/* harmony import */ var components_Layout_Column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77253);
/* harmony import */ var state_user_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72135);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5305);
/* harmony import */ var _pancakeswap_utils_truncateHash__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34766);
/* harmony import */ var state_lists_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7083);
/* harmony import */ var components_Logo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47269);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65957);
/* harmony import */ var utils_wagmi__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47945);
/* harmony import */ var hooks_useActiveChainId__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76166);













var getStandard = function(chainId) {
    return chainId !== _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .ChainId.BSC */ .a_.BSC && chainId !== _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .ChainId.BSC_TESTNET */ .a_.BSC_TESTNET ? "ERC20" : "BEP20";
};
function ImportToken(param) {
    var tokens = param.tokens, handleCurrencySelect = param.handleCurrencySelect;
    var ref;
    var chainId = (0,hooks_useActiveChainId__WEBPACK_IMPORTED_MODULE_10__/* .useActiveChainId */ .g)().chainId;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$G)().t;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), confirmed = ref1[0], setConfirmed = ref1[1];
    var addToken = (0,state_user_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useAddUserToken */ ._E)();
    // use for showing import source on inactive tokens
    var inactiveTokenList = (0,state_lists_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useCombinedInactiveList */ .qB)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_3__/* .AutoColumn */ .Tz, {
        gap: "lg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                variant: "warning",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    children: [
                        t("Anyone can create a %standard% token on %network% with any name, including creating fake versions of existing tokens and tokens that claim to represent projects that do not have a token.", {
                            standard: getStandard(chainId),
                            network: (ref = utils_wagmi__WEBPACK_IMPORTED_MODULE_9__/* .chains.find */ .p5.find(function(c) {
                                return c.id === chainId;
                            })) === null || ref === void 0 ? void 0 : ref.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        t("If you purchase an arbitrary token, you may be unable to sell it back.")
                    ]
                })
            }),
            tokens.map(function(token) {
                var ref, ref1;
                var list = token.chainId && (inactiveTokenList === null || inactiveTokenList === void 0 ? void 0 : (ref = inactiveTokenList[token.chainId]) === null || ref === void 0 ? void 0 : (ref1 = ref[token.address]) === null || ref1 === void 0 ? void 0 : ref1.list);
                var address = token.address ? "".concat((0,_pancakeswap_utils_truncateHash__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(token.address)) : null;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    gridTemplateRows: "1fr 1fr 1fr",
                    gridGap: "4px",
                    children: [
                        list !== undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            variant: "success",
                            outline: true,
                            scale: "sm",
                            startIcon: list.logoURI && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Logo__WEBPACK_IMPORTED_MODULE_7__/* .ListLogo */ ._r, {
                                logoURI: list.logoURI,
                                size: "12px"
                            }),
                            children: [
                                t("via"),
                                " ",
                                list.name
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            variant: "failure",
                            outline: true,
                            scale: "sm",
                            startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                color: "failure"
                            }),
                            children: t("Unknown Source")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    mr: "8px",
                                    children: token.name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    children: [
                                        "(",
                                        token.symbol,
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        token.chainId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            justifyContent: "space-between",
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    mr: "4px",
                                    children: address
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                    href: (0,utils__WEBPACK_IMPORTED_MODULE_5__/* .getBlockExploreLink */ .C)(token.address, "address", token.chainId),
                                    external: true,
                                    children: [
                                        "(",
                                        t("View on %site%", {
                                            site: (0,utils__WEBPACK_IMPORTED_MODULE_5__/* .getBlockExploreName */ .X0)(token.chainId)
                                        }),
                                        ")"
                                    ]
                                })
                            ]
                        })
                    ]
                }, token.address);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        alignItems: "center",
                        onClick: function() {
                            return setConfirmed(!confirmed);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                scale: "sm",
                                name: "confirmed",
                                type: "checkbox",
                                checked: confirmed,
                                onChange: function() {
                                    return setConfirmed(!confirmed);
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                ml: "8px",
                                style: {
                                    userSelect: "none"
                                },
                                children: t("I understand")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        variant: "danger",
                        disabled: !confirmed,
                        onClick: function() {
                            tokens.forEach(function(token) {
                                return addToken(token);
                            });
                            if (handleCurrencySelect) {
                                handleCurrencySelect(tokens[0]);
                            }
                        },
                        className: ".token-dismiss-button",
                        children: t("Import")
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ImportToken);


/***/ }),

/***/ 34188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hv": function() { return /* binding */ CurrencyModalView; },
/* harmony export */   "L0": function() { return /* binding */ CommonBasesType; }
/* harmony export */ });
var CurrencyModalView;
(function(CurrencyModalView) {
    CurrencyModalView[CurrencyModalView["search"] = 0] = "search";
    CurrencyModalView[CurrencyModalView["manage"] = 1] = "manage";
    CurrencyModalView[CurrencyModalView["importToken"] = 2] = "importToken";
    CurrencyModalView[CurrencyModalView["importList"] = 3] = "importList";
})(CurrencyModalView || (CurrencyModalView = {}));
var CommonBasesType;
(function(CommonBasesType) {
    CommonBasesType["LIQUIDITY"] = "LIQUIDITY";
    CommonBasesType["SWAP_LIMITORDER"] = "SWAP_LIMITORDER";
})(CommonBasesType || (CommonBasesType = {}));
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (CurrencyModalView)));


/***/ })

}]);